/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-23 13:19:08
 **/

import { BaseServiceV2 } from "@/frameworks/libraries/restservice";

class Emoji extends BaseServiceV2 {
	constructor() {
		super();
	}

	private APIPath = "/api/emoticons";

	public list = {
		name: "list",
		execute: (parameter: WebServices.Emoji.List.Request = {}): Promise<WebServices.Emoji.List.Response> =>
			this.get(this.list.name, this.APIPath, parameter)
	};

	public register = {
		name: "register",
		execute: (parameter: WebServices.Emoji.Register.Request = {}): Promise<WebServices.Emoji.Register.Response> =>
			this.post(this.register.name, this.APIPath, parameter)
	};
}

export default class EmojiService {
	constructor(
		events: API.Events,
		public emoji = new Emoji()
	) {
		emoji.set_event(events);
	}
}
